import { useCreateSubscription } from '@/hooks'
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useAccount } from 'wagmi'

export const CreateSubscriptionForm = ({ refetchSubs, ...params }) => {
  const { address } = useAccount()
  const { submit: createSubscription, isLoading } = useCreateSubscription({
    refetchSubs,
  })
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm()

  const onSubmit = () => {
    createSubscription()
  }

  useEffect(() => {
    setValue('address', address)
  }, [address, setValue])

  return (
    <Box {...params}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={errors.address}>
          <FormLabel htmlFor="address">Admin Address</FormLabel>
          <Input
            variant="filled"
            disabled
            bg={'primary.50'}
            _hover={{ bg: 'primary.100' }}
            id="address"
            placeholder="Admin Address"
            {...register('address', {
              value: address,
            })}
          />
          <FormErrorMessage>
            {errors.address && errors.address.message}
          </FormErrorMessage>
        </FormControl>
        <Button
          variant={'solid'}
          onClick={() => onSubmit()}
          mt={4}
          isLoading={isLoading}
          type="submit"
        >
          Submit
        </Button>
      </form>
    </Box>
  )
}
